export default __webpack_public_path__ + "static/media/hdb-blob-2.1944be32.svg";